import {styled} from "@mui/material/styles";
import {Button, Divider, Grid, Typography} from "@mui/material";

export const EditCompanyProfileColumnGap5 = styled(Grid)(() => ({
  columnGap: '0.36rem',
}));

export const EditCompanyProfileRowGap10 = styled(Grid)(() => ({
  rowGap: '0.71rem',
}));

export const EditCompanyProfileMarginTop20 = styled(EditCompanyProfileRowGap10)(() => ({
  marginTop: '1.43rem',
}));

export const EditCompanyProfileMarginTop20Divider = styled(Divider)(() => ({
  marginTop: '1.43rem',
}));

export const EditCompanyProfileMarginTop20Button = styled(Button)(() => ({
  marginTop: '1.43rem',
}));

export const EditCompanyProfileMarginBottom20 = styled(Typography)(() => ({
  marginBottom: '1.43rem',
}));

export const EditCompanyProfileLabelText = styled(Typography)(() => ({
  fontSize: '.85rem',
}));

export const EditCompanyProfileButton = styled(Button)(({theme}) => ({
  flexGrow: 1,
  [theme.breakpoints.up('sm')]: {
    width: 'auto',
    minWidth: '10.71em !important',
  }
}));
